import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Router } from '@angular/router';
import {CoreService, PageProps} from "../../shared/services/core.service";
import { SwiperOptions } from 'swiper';
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import {HOME_PATH} from "../../shared/constants";
import {UtilitiesService} from "../../shared/services/utilities.service";

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() brandName: string = "";
  scrollMargin: number = 130;
  swiperConfig: SwiperOptions;

  destroySubject$: Subject<void> = new Subject();
  pageProperties$: Observable<PageProps> = new Observable();

  constructor(
              private changeDetector: ChangeDetectorRef,
              private coreService: CoreService,
              private router: Router,
              private utils: UtilitiesService) {
    this.swiperConfig = {
      slidesPerView: 1,
      navigation: true,
    };
  }

  ngOnInit(): void {
    this.pageProperties$ = this.coreService.pagePropsSubject.pipe(takeUntil(this.destroySubject$));
  }

  ngOnDestroy(): void {
      this.destroySubject$.next();
  }

  ngAfterViewInit(): void {
    // BUGFIX for ExpressionChangedAfterItHasBeenCheckedError on MatCarouselComponent
    this.changeDetector.detectChanges();
  }

  isArrowVisible(): boolean {
    const {url} = this.router;
    return url === HOME_PATH;
  }

  startApplication() {
    // scroll into the sideNav view
    this.utils.scrollToElement("sidenav");
  }

  private setContentHeight(source: string, additionalMargin: number = 0): void {
    console.log("resizing content from " + source);

    // get the elements needed to calculate the height of the sidenav content
    let sidenav = document.getElementById("sidenav");
    let footer = document.getElementById("sticky-footer");
    let header = document.getElementById("header");

    // get the top of the sticky area
    let footerTopY = footer!.offsetTop;
    let headerBottomY = header!.getBoundingClientRect().bottom;

    console.log(`footerTopY: ${footerTopY}, headerBottomY: ${headerBottomY}, additionalMargin: ${additionalMargin}`);

    let height = `${footerTopY - headerBottomY - additionalMargin}px`;

    // set the height
    sidenav!.style.height = height;
  }

}
